import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  untracked } from '@angular/core';
import { ResolvableModal, Validators } from '@softline/ui-core';
import { WorkNote } from '../../data/work-note';

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { isDefinedNotEmpty } from '@softline/core';

type ModalParams = { email?: string } | null;

import { InputComponent } from '@softline/ui-core';
import { IsValidPipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
import { ValidationContainerComponent } from '@softline/ui-core';
import { ValidationMessagePipe } from '@softline/ui-core';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'lib-save-dialog',
    templateUrl: './save-dialog.component.html',
    styleUrls: ['./save-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule,
    InputComponent,
    IsValidPipe,
    TranslatePipe,
    ValidationContainerComponent,
    ValidationMessagePipe]
})
export class SaveDialogComponent extends ResolvableModal<ModalParams> {
  readonly form = new FormGroup({
    email: new FormControl<string | null>(null, Validators.multiEmail()) });

  readonly signatureMissing = computed(
    () => !isDefinedNotEmpty(this.workNote()?.signature)
  );

  quantitiesDone = input.required<boolean>();
  workNote = input.required<WorkNote>();

  constructor() {
    super();

    effect(() => {
      const workNote = this.workNote();
      untracked(() => {
        this.form.patchValue({
          email: workNote?.kopfau?.email ?? null });
      });
    });
  }

  close(): void {
    if (!this.form.valid) return;

    this.resolve({ email: this.form.value?.email ?? '' });
  }

  cancel(): void {
    this.resolve(null);
  }
}
